import { ChangeDetectionStrategy, Component, HostListener, input, signal } from '@angular/core';
import { TextModule } from '@library/ui/atoms/text/text.module';

@Component({
  selector: 'app-toolbar-item',
  imports: [
    TextModule,
  ],
  templateUrl: './toolbar-item.component.html',
  styleUrl: './toolbar-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarItemComponent {
  selected = input(false);
  label = input<string>();

  hover = signal(false);

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.hover.set(true);
  }

  @HostListener('click')
  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.hover.set(false);
  }
}
